<template>
  <div>
    <div :disabled="disabledButton" @click="showModal">
      <i
        @click="
          showModal;
          busHasBookings(busId);
        "
        :disabled="disabledButton"
        class="mr-2 fa fa-trash fa-fw"
      ></i
      >Eliminar
    </div>
    <b-modal ref="my-modal" hide-footer title="Eliminar bus">
      <div class="d-block">
        <div v-if="hasBookings.length == 0 ? true : hasBookings[0].response">
          <b-alert show variant="light">
            <i class="fa fa-info-circle">
              <span class="ml-1"
                >Hay buses disponibles. Si desea reasignar las reservas
                asociadas a este bus seleccione otro bus y clicke en el botón
                Reasignar</span
              >
            </i>
          </b-alert>
          <form>
            <div class="d-flex justify-content-center w-100">
              <div class="d-flex flex-column align-items-sm-baseline">
                <label>Buses disponibles</label>
                <b-form-select v-model="selectedBus">
                  <option :value="null">Seleccione un bus</option>
                  <option
                    v-for="bus in listBuses.filter(
                      (item) => item.id != busId && !item.bus_closed
                    )"
                    :key="bus.id"
                    :label="bus.name"
                    :value="bus.id"
                  ></option>
                </b-form-select>
              </div>
            </div>
          </form>
          <span v-if="selectedBus === null" class="text-primary"
            >Seleccione el bus al que desea mover las reservas</span
          >
          <b-button
            v-if="selectedBus !== null"
            size="sm"
            variant="secondary"
            @click="moveAllBookings(busId, selectedBus)"
            class="text-white"
            >Reasignar</b-button
          >
        </div>
        <div v-else>
          <b-alert show variant="light">
            <i class="fa fa-info-circle">
              <span class="ml-1"
                >El bus se encuentra vacío o no hay más buses disponibles</span
              >
            </i>
          </b-alert>
        </div>
      </div>
      <br />
      <div class="text-center">
        <b-button pill variant="ligth" @click="hideModal">
          <i class="fa fa-ban mr-1" aria-hidden="true"></i>Cancelar
        </b-button>
        <b-button
          v-if="hasBookings.length == 0 ? true : hasBookings[0].response"
          pill
          variant="dark"
          @click="moveAllBookings(busId, '0')"
          class="ml-3"
        >
          <i class="fa fa-floppy-o mr-1" aria-hidden="true"></i>Eliminar
        </b-button>
        <b-button
          v-else
          pill
          variant="dark"
          @click="deleteBus(busId)"
          class="ml-3"
        >
          <i class="fa fa-floppy-o mr-1" aria-hidden="true"></i>Eliminar
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "DeleteBusModal",
  props: ["listBuses", "busId", "disabledButton"],
  data() {
    return {
      dialogVisible: false,
      selectedBus: null,
    };
  },
  computed: {
    ...mapGetters(["buses"]),
    ...mapGetters(["bookings"]),
    ...mapGetters(["hasBookings"]),
  },
  methods: {
    showModal() {
      this.$refs["my-modal"].show();
    },
    hideModal() {
      this.$refs["my-modal"].hide();
    },

    busHasBookings(id) {
      this.$store.dispatch("buses/hasBookings", id);
    },

    // eliminamos el bus seleccionado (si no tiene reservas asociadas)
    deleteBus(id) {
      this.$store.dispatch("buses/deleteBus", id);
      this.dialogVisible = false;
      this.$notify({
        group: "foo",
        title: "Bus eliminado",
        text: "Se ha eliminado con éxito bus seleccionado",
        type: "info",
      });
      this.hideModal();
    },

    // Cambiar por otro bus seleccionado en todas estas reservas o pasar a null el bus a eliminar en todas las reservas en las que está asignado
    async moveAllBookings(idBusInitial, idBusFinal) {
      const payload = {
        bus_initial: idBusInitial,
        bus_final: idBusFinal,
        bus_type:
          this.$route.path == "/app/excursiones/excursiones" ? "Excursion" : "Pickup",
      };
      try {
        await this.$store.dispatch("bookingsBus/moveAllBuses", payload);
      } catch (ex) {
        this.error = "Failed to load data";
      } finally {
        this.deleteBus(idBusInitial);
        this.hideModal();
      }
    },
  },
};
</script>
